<template>
    <div>

        <div class="register__section">
            <div class="register__wrapper">
                <h2 class="register__heading h1" v-translate>registration_step_2_title</h2>
                <div class="register__intro" v-translate>registration_step_2_intro</div>
            </div>
            <div class="register__wrapper register__wrapper--wide">
                <loader class="register__preloader" v-if="!goals.length"></loader>
                <transition name="fade">
                    <div v-if="goals.length" class="register__selection">
                        <div 
                            class="register__selection__item" 
                            v-for="goal in goals" 
                            :key="goal.id" 
                            @click="() => setGoal(goal.id)" 
                            :class="{'is-selected': registrationUser.goalId === goal.id}"
                        >{{ goal.name }}</div>
                    </div>
                </transition>
                <div class="form__error form__error--center" v-if="errors.indexOf('goalId') >= 0" v-translate>registration_step_2_goal_error</div>
            </div>
        </div>
        <div class="register__section">
            <div class="register__wrapper">
                <h2 class="register__heading h1" v-translate>registration_step_2_interest_title</h2>
                <div class="register__intro" v-translate>registration_step_2_interest_intro</div>
            </div>
            <div class="register__wrapper register__wrapper--wide">
                <loader class="register__preloader" v-if="!interests.length"></loader>
                <transition name="fade">
                    <div v-if="interests.length" class="register__selection">
                        <div 
                            class="register__selection__item" 
                            v-for="interest in interests" 
                            :key="interest.id"
                            @click="() => setInterest(interest.id)" 
                            :class="{'is-selected': registrationUser.interestsIds.indexOf(interest.id) >= 0}"
                        >{{ interest.name }}</div>
                    </div>
                </transition>
                <div class="form__error form__error--center" v-if="errors.indexOf('interestsIds') >= 0" v-translate>registration_step_2_interest_error</div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'

import * as api from '../api'
export default {
    props: {
        errors: {
            type: Array,
            default: []
        }
    },
    data() {
        return {
            goals: [],
            interests: [],
        }
    },
    created() {
        this.fetchGoals();
        this.fetchInterests();
    },
    computed: {
        ...mapState({
            'registrationUser': 'registrationUser'
        }),
    },
    methods: {
        async fetchGoals() {
            if(this.goals.length) {
                return false;
            }
            try {
                const response = await api.goals();
                this.goals = response.data.data
            } catch (error) {
                console.error(error);
            }
        },
        async fetchInterests() {
            if(this.interests.length) {
                return false;
            }
            try {
                const response = await api.interests();
                this.interests = response.data.data
            } catch (error) {
                console.error(error);
            }
        },
        setGoal(id) {
            if(this.registrationUser.goalId === id ) {
                id = '';
            }
            this.$store.commit('setRegistrationUserGoal', id);
            this.$emit('changed');
        },
        setInterest(id) {
            let ids = this.registrationUser.interestsIds;
            if(ids.indexOf(id) >= 0 ) {
                ids.splice(ids.indexOf(id), 1);
            } else {
                ids.push(id);
            }
            this.$store.commit('setRegistrationUserInterests', ids);
            this.$emit('changed');
        },
    }
}
</script>

<style lang="scss">
// styles in "RegistrationSteps" component
</style>
